module.exports = __webpack_public_path__ + "static/media/down.20436f7c.svg";